import { useState } from "react";
import { Play, X } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { fileUrl, youtubeId } from "@/lib/api";
import { PageHero, Empty } from "@/components/kit";
import { useFetch } from "@/components/shared";
import { FilterTabs } from "./News";
import { STRUCTURE_LABEL } from "@/lib/content";

function MediaView({ item }) {
  const yt = youtubeId(item.url);
  if (item.type === "video" && yt)
    return <iframe title={item.title} src={`https://www.youtube-nocookie.com/embed/${yt}`} className="aspect-video w-full" allowFullScreen />;
  if (item.type === "video") return <video src={fileUrl(item.url)} controls className="max-h-[80vh] w-full" />;
  return <img src={fileUrl(item.url)} alt={item.title} className="max-h-[82vh] w-full object-contain" />;
}

export default function Gallery() {
  useSeo("Galerie", "Photos et vidéos de l'ONG MA LEBA et de l'ASSOCIATION MA LEBA.");
  const [structure, setStructure] = useState("");
  const [open, setOpen] = useState(null);
  const media = useFetch(`/media${structure ? `?structure=${structure}` : ""}`, [structure]);
  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="Photos & vidéos" title="Galerie" intro="Nos actions en images." />
      <section className="container-x py-14">
        <FilterTabs value={structure} onChange={setStructure} testid="gallery-filter"
          options={[["", "Tout"], ["ong", "ONG"], ["association", "Association"], ["commun", "Commun"]]} />
        <div className="mt-8 columns-2 gap-4 md:columns-3 lg:columns-4">
          {(media || []).map((m, i) => (
            <button key={m.id} onClick={() => setOpen(m)} data-testid={`gallery-item-${i}`}
              className="group relative mb-4 block w-full break-inside-avoid overflow-hidden rounded-xl bg-white text-left shadow-sm">
              {m.type === "video" ? (
                <div className="flex aspect-video items-center justify-center bg-ink">
                  {youtubeId(m.url) && <img src={`https://img.youtube.com/vi/${youtubeId(m.url)}/hqdefault.jpg`} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-70" />}
                  <Play className="relative h-12 w-12 text-white" aria-hidden="true" />
                </div>
              ) : (
                <img src={fileUrl(m.url)} alt={m.title} loading="lazy" className="w-full transition-transform duration-500 group-hover:scale-105" />
              )}
              <div className="p-3">
                <p className="text-xs font-semibold uppercase text-u">{STRUCTURE_LABEL[m.structure]}</p>
                <p className="text-sm font-medium text-ink">{m.title}</p>
              </div>
            </button>
          ))}
        </div>
        {media && !media.length && <Empty testid="gallery-empty">Aucun média pour le moment.</Empty>}
      </section>
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4" role="dialog" aria-modal="true" aria-label={open.title}
          onClick={() => setOpen(null)} data-testid="gallery-lightbox">
          <button className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white" aria-label="Fermer" data-testid="gallery-lightbox-close"><X className="h-6 w-6" /></button>
          <div className="w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <MediaView item={open} />
            <p className="mt-3 text-center text-white">{open.title}</p>
          </div>
        </div>
      )}
    </div>
  );
}
